<div class="pagination-container">
  <!-- Información de registros y selector de tamaño de página -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <span *ngIf="data.length > 0">
        Mostrando {{ startItem }}-{{ endItem }} de {{ data.length }} registros
      </span>
      <span *ngIf="data.length === 0">
        No hay registros para mostrar
      </span>
    </div>
    <div class="d-flex align-items-center">
      <label class="me-2">Registros por página:</label>
      <select 
        class="form-select form-select-sm" 
        style="width: auto;" 
        [(ngModel)]="pageSize" 
        (change)="onPageSizeChange(pageSize)">
        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>

  <!-- Navegación de páginas -->
  <nav aria-label="Paginación">
    <ul class="pagination">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link" (click)="goToPage(currentPage-1)" [disabled]="currentPage === 1">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
      </li>
      
      <li class="page-item" *ngFor="let p of pages" [class.active]="currentPage === p">
        <button class="page-link" (click)="goToPage(p)">{{ p }}</button>
      </li>
      
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link" (click)="goToPage(currentPage+1)" [disabled]="currentPage === totalPages">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </li>
    </ul>
  </nav>
</div> 